import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Art } from './Art';
import { VanShape } from './KeiVan';
/**
 * A mountain road in Japan: a snow-capped peak and nearer ridges, pines, a small vermilion
 * torii by the road, and the kei van climbing the switchback. 260 × 150.
 */ export function MountainRoad({ title, className }) {
    return /*#__PURE__*/ _jsxs(Art, {
        viewBox: "0 0 260 150",
        title: title,
        className: className,
        children: [
            /*#__PURE__*/ _jsx("circle", {
                className: "fo n",
                cx: "206",
                cy: "30",
                r: "13",
                opacity: ".9"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fa2",
                d: "m84 110 60-84 56 84Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fc",
                d: "m130 46 14-20 15 22-8 4-6-6-7 6Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fh",
                d: "M-4 120c30-30 60-44 92-44 30 0 50 22 82 22 34 0 60-22 94-22v74H-4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fc",
                d: "M-4 140c40-6 90-12 130-20 34-7 60-20 140-22v8c-74 2-104 16-138 23-40 8-92 14-132 19Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "sa thin",
                d: "M20 141l14-2M60 135l14-2M100 129l14-3M150 117l14-4M196 107l14-2M236 103l14-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fa",
                d: "m22 112 9-22 9 22Zm-4-11 13-16 13 16Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fa",
                d: "m226 96 7-17 7 17Zm-3-9 10-12 10 12Z"
            }),
            /*#__PURE__*/ _jsx("g", {
                className: "sb",
                strokeWidth: "2.4",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M58 90h26M60 95h22M64 95v18M78 95v18"
                })
            }),
            /*#__PURE__*/ _jsx("g", {
                transform: "translate(118 84) scale(.42) rotate(-8 64 60)",
                children: /*#__PURE__*/ _jsx(VanShape, {})
            })
        ]
    });
}
